<template>
	<div style="text-align: left; margin-top: 4px">
		<div>
			<md-button
				class="md-icon-button sidebar-md-icon-button"
				v-if="is_show_type_button">
				<md-icon class="edit-icon" style="font-size: 16px !important;">
					{{ type_icon }}
				</md-icon>
			</md-button>
			<md-button
				class="md-icon-button sidebar-md-icon-button"
				v-if="is_show_right_button"
				@click="click_show_more">
				<md-icon class="edit-icon">
					keyboard_arrow_right
				</md-icon>
			</md-button>
			<md-button
				class="md-icon-button sidebar-md-icon-button"
				v-if="is_show_down_button"
				@click="click_hide_more">
				<md-icon class="edit-icon">
					keyboard_arrow_down
				</md-icon>
			</md-button>
			<md-button
				class="md-icon-button sidebar-md-icon-button"
				v-if="is_show_space_button">
				<md-icon class="edit-icon">
				</md-icon>
			</md-button>
			<md-button
				class="md-icon-button sidebar-md-icon-button"
				v-if="is_show_edit_button">
				<md-icon class="edit-icon" style="font-size: 16px !important;">
					settings
				</md-icon>
			</md-button>
			<a
				class="tag-name"
				:class='{"selected-tag-name": isSelected}'
				@click="click_tag">
				{{ body.name }}
				{{ edit_tag_label }}
				<span class="tag-count">
					{{ body.count }}
				</span>
			</a>
		</div>
		<ul v-show="is_show_down_button">
			<li
				v-for="tag in body.children_tag"
				:key="tag.id"
				>
				<Tag
					:body="tag"
				/>
			</li>	
		</ul>
	</div>
</template>
<script>
import Tag from './Tag.vue'

export default {
	name: 'Tag',
	components: {
		Tag
	},
	props: {
		body: {
			type: Object,
			required: true
		}
	},
	methods: {
		click_tag() {
			console.log('this.body.id', this.body.id)
			if (this.body.id == 'edit_tag') {
				this.switch_is_editing_tags()
				return
			}
			if (!this.is_editing_tags) {
				if (this.body.id == 'all_tag') {
					this.$store.dispatch('tags/set_selected', '')
				} else {
					this.$store.dispatch('tags/set_selected', this.body.id)
				}
			} else {
				if (this.body.id !== 'all_tag') {
					this.$store.commit('tags/update_editing_tag', this.body.id)
				}
			}
		},
		click_show_more() {
			this.$store.commit('tags/update_show_more', this.body.id)
		},
		click_hide_more() {
			this.$store.commit('tags/update_hide_more', this.body.id)
		},
		switch_is_editing_tags() {
			this.$store.commit('tags/switch_is_editing_tags')
		}
	},
	computed: {
		isSelected() {
			if (this.is_editing_tags) { //編集中
				if (this.body.id == 'edit_tag') {
					return this.$store.state.tags.is_editing_tags === true
				} else {
					return (this.body.id == this.$store.state.tags.editing_tag_id)
				}
			} else { //通常時
				if (this.body.id == 'all_tag') {
					return this.$store.state.tags.selected === ''
				} else {
					return this.$store.state.tags.selected === this.body.id		
				}
			}
		},
		tagCount: function () {
			return this.body.count
		},
		is_editing_tags() {
			return this.$store.state.tags.is_editing_tags
		},
		is_show_more() {
			const show_more_tag = this.$store.getters['tags/show_more_tags'][this.body.id]
			if (!show_more_tag || !this.body.children_tag) {
				return false
			} else {
				return true
			}
		},
		is_show_right_button() {
			const show_more_tag = this.$store.getters['tags/show_more_tags'][this.body.id]
			return (!show_more_tag && this.body.children_tag && this.body.children_tag.length > 0 )
		},
		is_show_down_button() {
			const show_more_tag = this.$store.getters['tags/show_more_tags'][this.body.id]
			return (show_more_tag && this.body.children_tag && this.body.children_tag.length > 0 )
		},
		is_show_space_button() {
			return (!this.is_show_down_button && !this.is_show_right_button && this.body.id !== 'edit_tag' && this.body.id !== 'all_tag')
		},
		is_show_edit_button() {
			return (this.body.id == 'edit_tag')
		},
		is_show_type_button() {
			return (this.body.id == 'all_tag')
		},
		type_icon() {
			switch (this.$store.state.tabs.filterType) {
				case 'inbox':
					return 'inbox'
				case 'done':
					return 'done'
				case 'deferred':
					return 'alarm'
				default:
					break;
			}
			// return (this.body.id == 'all_tag')
		},
		edit_tag_label() {
			if (this.body.id == 'edit_tag') {
				if (this.is_editing_tags) { //編集中
					return '終了'
				} else {
					return 'Edit'
				}	
			}
		}
	}
}
</script>
<style>
/*
.selected-tag {
	color: aliceblue !important;
	font-weight: bold;
}
.selected-tag:hover {
    background-color: #6EBD91 !important;
}
.selected-tag-count {
	color: rgba(0, 0, 0, 0.87);
	font-weight: 100;
}
.chip {
	height: 28px;
	line-height: 28px;
	margin-bottom: 12px;

}*/
.tag-count {
	font-size: 12px;
	margin-right: -8px;
	/* background: white; */
	padding: 2px 6px;
	/* border-radius: 12px; */
	color: rgba(0, 0, 0, 0.87);
}

ul {
	/* padding-left: 1em; */
	margin-left: 16px !important;
	line-height: 1.5em;
	list-style-type: dot;
}

.edit-icon {
	font-size: 24px !important;
}

.sidebar-md-icon-button {
	min-height: 18x !important;
	height: 18px !important;
	min-width: 18px !important;
	width: 18px !important;
	margin: 0px !important;
}

.left-label {
	min-height: 20x !important;
	height: 20px !important;
	min-width: 20px !important;
	width: 20px !important;
}

.tag-name {
	text-decoration:none !important;
	color:black !important;
}
.tag-name:hover {
    color: #6EBD91 !important;
}

.selected-tag-name {
	text-decoration:none !important;
	font-weight: bold;
	color: #6EBD91 !important;
}
</style>
